import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle || "Servio's porfolio "}</title>
                    <meta name="description" content="servio's portafolio" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
